import { createFileRoute } from "@tanstack/react-router";
import { OfficialPresetsTable } from "@/components/admin/official-presets-table";
import { usePageTitle } from "@/hooks/use-page-title";
import { adminPresetsQueryOptions } from "@/lib/api/admin-official-presets";

export const Route = createFileRoute("/dashboard/admin/official-presets")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(adminPresetsQueryOptions({})),
  component: AdminOfficialPresetsPage,
});

function AdminOfficialPresetsPage() {
  usePageTitle("Admin - Official Presets");
  return <OfficialPresetsTable />;
}
